import * as React from "react";
import {inject, observer} from "mobx-react";
import { AppStore } from "Stores/appStore";
import { BannerStore } from "Stores/bannerStore";
import BannerItem from "Components/Common/BannerItem";


interface BannerListProps {
    isAuthenticated: boolean
    appStore?: AppStore
    bannerStore?: BannerStore
}


@inject("appStore", "bannerStore")
@observer
export class BannerList extends React.Component<BannerListProps, any>{

    componentDidMount() {
        if (!this.props.bannerStore) {
            return null;
        }
        if (this.props.isAuthenticated) {
            this.props.bannerStore.fetchBanners();
        } else {
            const subdomain = window.location.hostname.split(".")[0];
            this.props.bannerStore.fetchBannersBySubdomain(subdomain);
        }
    }

    handleCloseBanner(bannerRuuid: string) {
        if (!this.props.bannerStore) {
            return;
        }

        this.props.bannerStore.dismissBanner(bannerRuuid);
    }

    handleLike(ruuid: string) {
        if (!this.props.bannerStore) {
            return;
        }
        this.props.bannerStore.likeBanner(ruuid);
    }
    handleRemindMeLater(bannerRuuid: string) {
        if (!this.props.bannerStore) {
            return;
        }
        this.props.bannerStore.remindMeLater(bannerRuuid);
    }

    render() {
        if (!this.props.bannerStore || this.props.bannerStore.banners.length === 0) {
            return null;
        }
        const currentBanner = this.props.bannerStore.banners[0];

        return (
            <div className="banner-list">
                <BannerItem
                    item={currentBanner}
                    key={currentBanner.ruuid}
                    isAuthenticated={this.props.isAuthenticated}
                    onLike={() => this.handleLike(currentBanner.ruuid)}
                    onRemindMeLater={() => this.handleRemindMeLater(currentBanner.ruuid)}
                    onClose={() => this.handleCloseBanner(currentBanner.ruuid)} />
            </div>
        );
    }
}